'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var react = require('@emotion/react');
var styled = require('@emotion/styled');
var legacy_Typography_Paragraph = require('../../legacy/Typography/Paragraph.js');
require('@babel/runtime/helpers/extends');
require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
require('../../legacy/Typography/Text.js');
require('@styled-system/should-forward-prop');
require('styled-system');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var listViewStyle = function listViewStyle(theme, headerTitle) {
  return (
    /*#__PURE__*/
    /*#__PURE__*/
    react.css("flex-direction:row;overflow:hidden;", !headerTitle && "\n    border-top-right-radius: ".concat(theme.radii.medium, ";\n    border-bottom-right-radius: ").concat(theme.radii.medium, ";\n    "), ";", headerTitle && "\n    border-bottom-left-radius: ".concat(theme.radii.medium, ";\n    border-bottom-right-radius: ").concat(theme.radii.medium, ";\n    "), ";" + ("production" === "production" ? "" : ";label:listViewStyle;"), "production" === "production" ? "" : ";label:listViewStyle;")
  );
};
var galleryViewStyle = function galleryViewStyle(theme, headerTitle) {
  return (
    /*#__PURE__*/
    /*#__PURE__*/
    react.css("flex-direction:column;overflow:hidden;", !headerTitle && "\n    border-bottom-left-radius: ".concat(theme.radii.medium, ";\n    border-bottom-right-radius: ").concat(theme.radii.medium, ";\n    "), ";" + ("production" === "production" ? "" : ";label:galleryViewStyle;"), "production" === "production" ? "" : ";label:galleryViewStyle;")
  );
};
var CardContentWrapperListViewStyle = "production" === "production" ? {
  name: "k2r4iw",
  styles: "flex:1;min-height:128px;overflow:hidden"
} : {
  name: "lz4pq5-CardContentWrapperListViewStyle",
  styles: "flex:1;min-height:128px;overflow:hidden;label:CardContentWrapperListViewStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var cardTitle = function cardTitle(theme) {
  return "\n    color: ".concat(theme.colors['$02_red_light'], ";\n    padding: ").concat(theme.space[6], ";\n    background-color: ").concat(theme.colors['$02_red_light'], ";\n    text-align: center;\n");
};
var GridCardHeader = styled__default["default"](legacy_Typography_Paragraph.Paragraph8)(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return cardTitle(theme);
});
var ListCardHeader = styled__default["default"](legacy_Typography_Paragraph.Paragraph8)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    ", ";\n    ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return cardTitle(theme);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "\n        border-top: 1px solid ".concat(theme.colors['$02_red_light'], ";\n        border-right: 1px solid ").concat(theme.colors['$02_red_light'], ";\n        border-left: 1px solid ").concat(theme.colors['$02_red_light'], ";\n        border-top-left-radius:").concat(theme.radii.medium, ";\n        border-top-right-radius:").concat(theme.radii.medium, ";\n    ");
});
var gridCardBorder = function gridCardBorder(theme) {
  return "\n    border: 1px solid ".concat(theme.colors['$02_red_light'], ";\n    border-radius:").concat(theme.radii.medium, ";\n");
};
var listCardBorder = function listCardBorder(theme) {
  return "\n    border-bottom: 1px solid ".concat(theme.colors['$02_red_light'], ";\n    border-right: 1px solid ").concat(theme.colors['$02_red_light'], ";\n    border-left: 1px solid ").concat(theme.colors['$02_red_light'], ";\n");
};
var SCard = styled__default["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    display: flex;\n    height: ", ";\n    ", ";\n    ", "\n"])), function (_ref4) {
  var type = _ref4.type,
    headerTitle = _ref4.headerTitle;
  return type === 'list' && headerTitle ? 'auto' : '100%';
}, function (props) {
  return props.type === 'list' ? listViewStyle(props.theme, props.headerTitle) : galleryViewStyle(props.theme, props.headerTitle);
}, function (_ref5) {
  var theme = _ref5.theme,
    headerTitle = _ref5.headerTitle,
    type = _ref5.type;
  return "\n        ".concat(headerTitle && type === 'list' && listCardBorder(theme), ";\n        ").concat(headerTitle && type !== 'list' && gridCardBorder(theme), ";\n    ");
});
var SCardContent = styled__default["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    background-color: ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 112px;\n    ", ";\n    padding: ", ";\n    position: relative;\n    ", ";\n    word-break: break-word;\n"])), function (props) {
  return props.theme.colors['background-global-primary'];
}, function (_ref6) {
  var type = _ref6.type;
  return type === 'grid' && 'flex: 1 0 auto';
}, function (_ref7) {
  var theme = _ref7.theme,
    size = _ref7.size;
  return size === 'small' ? theme.space[8] : theme.space[16];
}, function (_ref8) {
  var type = _ref8.type;
  return type === 'list' && CardContentWrapperListViewStyle;
});
var CardThumbnailListViewStyle = "production" === "production" ? {
  name: "1gpt1o6",
  styles: "flex-shrink:0;max-width:45%;width:150px"
} : {
  name: "o4wyp3-CardThumbnailListViewStyle",
  styles: "flex-shrink:0;max-width:45%;width:150px;label:CardThumbnailListViewStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var SCardThumbnail = styled__default["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral__default["default"](["\n    ", ";\n\n    position: relative;\n"])), function (_ref9) {
  var type = _ref9.type;
  return type === 'list' && CardThumbnailListViewStyle;
});
var SBadges = styled__default["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral__default["default"](["\n    bottom: 0;\n    display: flex;\n    flex-direction: column-reverse;\n    height: 100%;\n    justify-content: space-between;\n    left: 0;\n    position: absolute;\n    width: 100%;\n"])));
var CardTitle = styled__default["default"](legacy_Typography_Paragraph.Paragraph4)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral__default["default"](["\n    /* CSS magic to truncate lines */\n    /* stylelint-disable-next-line property-no-vendor-prefix */\n    -webkit-box-orient: vertical;\n    /* stylelint-disable-next-line value-no-vendor-prefix */\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    margin-bottom: auto;\n    overflow: hidden;\n"])));
var CardPrice = styled__default["default"](legacy_Typography_Paragraph.Paragraph3)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral__default["default"](["\n    display: block;\n    font-weight: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.fontWeights.bold);
});
var NewPrice = styled__default["default"].span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    margin-right: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors['text-global-error'];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space[10];
});
var OriginalPrice = styled__default["default"].span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    text-decoration: line-through;\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors['text-global-secondary'];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space[12];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space[14];
});
var CardParams = styled__default["default"](legacy_Typography_Paragraph.Paragraph8)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral__default["default"](["\n    align-items: center;\n    display: flex;\n"])));

exports.CardParams = CardParams;
exports.CardPrice = CardPrice;
exports.CardTitle = CardTitle;
exports.GridCardHeader = GridCardHeader;
exports.ListCardHeader = ListCardHeader;
exports.NewPrice = NewPrice;
exports.OriginalPrice = OriginalPrice;
exports.SBadges = SBadges;
exports.SCard = SCard;
exports.SCardContent = SCardContent;
exports.SCardThumbnail = SCardThumbnail;
exports.listCardBorder = listCardBorder;
//# sourceMappingURL=Card.style.js.map
